import "./base.js";
import "../../../shared/components/sparkle_loader.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};

AppointmentBooking.Wizard.Views.LoadingIndicator = class LoadingIndicator extends AppointmentBooking.Wizard.Views.Base {
  constructor() {
    super(...arguments);
    this.preinitialize = this.preinitialize.bind(this);
    this.initialize = this.initialize.bind(this);
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
    this.showWithTimeout = this.showWithTimeout.bind(this);
    this.hideWithTimeout = this.hideWithTimeout.bind(this);
    this.showWithoutTimeout = this.showWithoutTimeout.bind(this);
    this.trackShownTime = this.trackShownTime.bind(this);
    this.hideAfterShownForMinTime = this.hideAfterShownForMinTime.bind(this);
    this.delayHide = this.delayHide.bind(this);
    this.remainingMinShowTime = this.remainingMinShowTime.bind(this);
    this.shownFor = this.shownFor.bind(this);
    this.clearShownForTimer = this.clearShownForTimer.bind(this);
    this.hideWithoutTimeout = this.hideWithoutTimeout.bind(this);
  }

  preinitialize() {
    this.loadingIndicator = new SparkleLoader();
    return (this.el = this.loadingIndicator.el);
  }

  initialize(options) {
    this.$el.addClass(this.className);
    this.options = jQuery.extend(
      {
        delay: 0, // How long to wait before showing the indicator if it hasn't been hidden in the meantime
        min: 0, // The minimum amount of time the indicator must display for if shown
      },
      options,
    );

    return (this.count = 0); // Many overlapping things may hide or show the indicator, so only hide it once all are complete
  }

  // DSL

  show() {
    if (!this.count++) {
      return this.showWithTimeout();
    }
  }

  hide() {
    if (!this.count) {
      return;
    }
    if (!--this.count) {
      return this.hideWithTimeout();
    }
  }

  // PRIVATE

  showWithTimeout() {
    if (this.timeout) {
      return;
    }
    return (this.timeout = setTimeout(this.showWithoutTimeout, this.options.delay));
  }

  hideWithTimeout() {
    clearTimeout(this.timeout);
    delete this.timeout;
    return this.hideAfterShownForMinTime();
  }

  showWithoutTimeout() {
    this.trackShownTime();
    return this.$el.show();
  }

  trackShownTime() {
    this.clearShownForTimer();
    return (this.shownAt = new Date());
  }

  hideAfterShownForMinTime() {
    this.clearShownForTimer();
    return (this.minVisibilityTimeout = this.delayHide(this.remainingMinShowTime()));
  }

  delayHide(delay) {
    return setTimeout(this.hideWithoutTimeout, delay);
  }

  remainingMinShowTime() {
    return Math.max(this.options.min - this.shownFor(), 0);
  }

  shownFor() {
    if (this.shownAt) {
      return new Date() - this.shownAt;
    } else {
      return 0;
    }
  }

  clearShownForTimer() {
    clearTimeout(this.minVisibilityTimeout);
    return delete this.shownAt;
  }

  hideWithoutTimeout() {
    return this.$el.hide();
  }
};
AppointmentBooking.Wizard.Views.LoadingIndicator.prototype.template = false;
AppointmentBooking.Wizard.Views.LoadingIndicator.prototype.className = "appointment-booking-wizard-loading-indicator";
